import { baseApi } from "./baseApi";

const pricingApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    runPricing: builder.mutation({
      query: (body) => ({
        url: "/pricing/run",
        method: "POST",
        body,
      }),
    }),
    runLoanPricing: builder.mutation({
      query: ({ loanId, pricingRequest }) => ({
        url: `/loans/${loanId}/pricing/run`,
        method: "POST",
        body: { pricingRequest },
      }),
    }),
  }),
});

/**
 * Runs pricing via Ratesboard or Optimal Blue depending on the optimalBluePricing feature flag.
 * Loan-scoped surfaces pass loanId; pre-loan surfaces use POST /pricing/run (scenario loan on server).
 */
export async function runPricingWithEngine({
  featureFlags,
  pricingRequest,
  loanId,
  runPricing,
  runLoanPricing,
}) {
  const useOb = featureFlags?.optimalBluePricing === true;
  if (useOb && loanId) {
    return runLoanPricing({ loanId, pricingRequest }).unwrap();
  }
  return runPricing({ pricingRequest }).unwrap();
}

export default pricingApi;
